import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { TBudgetarySurplusRange, TFunding, TPortfolio } from '@dekafvv/sharedfrontend';
import type {
    TAnswers,
    TExAnteSavings,
    TFees,
    TValidations,
} from './types';
import { initialState } from './data';

const reducers = {
    setAnswers: (state, action: PayloadAction<Partial<TAnswers>>) => ({
        ...state,
        answers: {
            ...state.answers,
            ...action.payload,
        },
    }),
    setSavingPortfolio: (state, action: PayloadAction<TPortfolio>) => ({
        ...state,
        portfolio: {
            ...action.payload,
        },
    }),
    setSavings: (state, action: PayloadAction<TFunding | undefined>) => ({
        ...state,
        saving: action.payload,
    }),
    setTransactionDate: (state, action: PayloadAction<string | undefined>) => ({
        ...state,
        transactionDate: action.payload,
    }),
    setValidations: (state, action: PayloadAction<TValidations>) => ({
        ...state,
        validations: action.payload,
    }),
    setExAnteSavings: (state, action: PayloadAction<TExAnteSavings | null>) => ({
        ...state,
        exAnteSavings: action.payload,
    }),
    setFundingId: (state, action: PayloadAction<number | null>) => ({
        ...state,
        fundingId: action.payload,
    }),
    setSavingFees: (state, action: PayloadAction<TFees | null>) => ({
        ...state,
        fees: action.payload,
    }),
    setFundings: (state, action: PayloadAction<TFunding[]>) => ({
        ...state,
        fundings: action.payload,
    }),
    setInitialSavingState: (state) => ({
        ...state,
        ...initialState,
    }),
    setBudgetarySurplus: (state, action: PayloadAction<number>) => ({
        ...state,
        budgetarySurplus: action.payload,
    }),
    setBudgetarySurplusRange: (state, action: PayloadAction<TBudgetarySurplusRange>) => ({
        ...state,
        budgetarySurplusRange: action.payload,
    }),
};

export const savingPlansSlice = createSlice({
    name: 'savingPlans',
    initialState,
    reducers,
});
